export default [
  {
    label: 'Colors',
    styles: [
      {
        description: 'White',
        cssClass: 'body',
        cssProperty: '--white',
        cssValue: '#FFFFFF'
      },
      {
        description: 'Black',
        cssClass: 'body',
        cssProperty: '--black',
        cssValue: '#000000'
      },
      {
        description: 'Galaxy Blue',
        cssClass: 'body',
        cssProperty: '--galaxyBlue',
        cssValue: '#2A4B7C'
      },
      {
        description: 'Airy Blue',
        cssClass: 'body',
        cssProperty: '--airyBlue',
        cssValue: '#92B6D5'
      },
      {
        description: 'Midnight Blue',
        cssClass: 'body',
        cssProperty: '--midnightBlue',
        cssValue: '#053147'
      },
      {
        description: 'Sailor Blue',
        cssClass: 'body',
        cssProperty: '--sailorBlue',
        cssValue: '#2E4A62'
      },
      {
        description: 'Buttercup Yellow',
        cssClass: 'body',
        cssProperty: '--buttercupYellow',
        cssValue: '#FAE03C'
      },
      {
        description: 'Dark Cheddar',
        cssClass: 'body',
        cssProperty: '--darkCheddar',
        cssValue: '#E08119'
      },
      {
        description: 'Orange Tiger',
        cssClass: 'body',
        cssProperty: '--orangeTiger',
        cssValue: '#F96714'
      },
      {
        description: 'Light Gray',
        cssClass: 'body',
        cssProperty: '--lightGray',
        cssValue: '#F9F9FB'
      },
      {
        description: 'Soft Gray',
        cssClass: 'body',
        cssProperty: '--softGray',
        cssValue: '#D3D3D3'
      },
      {
        description: 'Solid Gray',
        cssClass: 'body',
        cssProperty: '--solidGray',
        cssValue: '#838383'
      },
      {
        description: 'Mid Gray',
        cssClass: 'body',
        cssProperty: '--midGray',
        cssValue: '#C5C2C2'
      },
      {
        description: 'Deep Green',
        cssClass: 'body',
        cssProperty: '--deepGreen',
        cssValue: '#0D8050'
      },
      {
        description: 'Riverside Blue',
        cssClass: 'body',
        cssProperty: '--riversideBlue',
        cssValue: '#4C6A92'
      },
      {
        description: 'Island Paradise',
        cssClass: 'body',
        cssProperty: '--islandParadise',
        cssValue: '#95DEE3'
      },
      {
        description: 'Sky Blue',
        cssClass: 'body',
        cssProperty: '--skyBlue',
        cssValue: '#E4ECF5'
      },
      {
        description: 'Deep Gray',
        cssClass: 'body',
        cssProperty: '--deepGray',
        cssValue: '#2C3033'
      },
      {
        description: 'Dark Night',
        cssClass: 'body',
        cssProperty: '--darkNight',
        cssValue: '#212528'
      }
    ]

  }
  /* {
    label: 'General Theme Defaults',
    styles: [
      {
        description: 'No borders on slds icons',
        cssClass: '.slds-image--card',
        cssProperty: 'border',
        cssValue: 'none'
      },
      {
        description: 'Background color of every page in assignment',
        cssClass: '.assignment-preview',
        cssProperty: 'background-color',
        cssValue: '#F0F2F5'
      },
      {
        description: 'No borders on slds icons',
        cssClass: '.slds-box',
        cssProperty: 'border',
        cssValue: 'none'
      },
      {
        description: 'Grid Layout Background Color',
        cssClass: '.Grid.Layout',
        cssProperty: 'background-color',
        cssValue: '#F0F2F5'
      }
    ]
  },
  {
    label: 'Containers',
    styles: [
      {
        description: 'Container Label Color',
        cssClass: '.Container > div > label',
        cssProperty: 'color',
        cssValue: 'var(--tableLabelColor,#5a585f )'
      },
      {
        description: '',
        cssClass: '.outer-container > body',
        cssProperty: 'font-size',
        cssValue: '14px'
      },
      {
        description: '',
        cssClass: '.Container > div > div > div > span',
        cssProperty: 'font-weight',
        cssValue: 'bold'
      },
      {
        description: '',
        cssClass: '.Container > div > label',
        cssProperty: 'letter-spacing',
        cssValue: '0.4px'
      },
      {
        description: '',
        cssClass: '.Container > div > label',
        cssProperty: 'text-align',
        cssValue: 'center'
      },
      {
        description: '',
        cssClass: '.Container > div > label',
        cssProperty: 'flex-grow',
        cssValue: '1'
      },
      {
        description: '',
        cssClass: '.Container > div > label',
        cssProperty: 'align-self',
        cssValue: 'flex-end'
      },
      {
        description: '',
        cssClass: '.Content .Container',
        cssProperty: 'padding',
        cssValue: '5px'
      },
      {
        description: '',
        cssClass: '.Content .Container',
        cssProperty: 'border-radius',
        cssValue: '10px'
      },
      {
        description: '',
        cssClass: 'Container',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: 'Container',
        cssProperty: 'border-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Pie Charts',
    styles: [
      {
        description: '',
        cssClass: '.chart-title, .Pie >div >div',
        cssProperty: 'text-transform',
        cssValue: 'uppercase'
      },
      {
        description: '',
        cssClass: '.chart-title, .Pie >div >div',
        cssProperty: 'color',
        cssValue: 'var(--tableLabelColor,#5a585f)'
      },
      {
        description: 'Sections',
        cssClass: '.chart-title, .Pie >div >div',
        cssProperty: 'font-size',
        cssValue: '14px'
      },
      {
        description: '',
        cssClass: '.chart-title',
        cssProperty: 'font-weight',
        cssValue: 'bold'
      },
      {
        description: '',
        cssClass: '.chart-title, .Pie >div >div',
        cssProperty: 'letter-spacing',
        cssValue: '0.4px'
      },
      {
        description: '',
        cssClass: '.chart-title',
        cssProperty: 'padding',
        cssValue: '25px 0px 0px 25px'
      },
      {
        description: '',
        cssClass: '.chart-title, .Pie >div >div',
        cssProperty: 'margin',
        cssValue: '-16px'
      }
    ]
  },
  {
    label: 'Sections',
    styles: [
      {
        description: '',
        cssClass: '.section > div > div > div > div > div',
        cssProperty: 'color',
        cssValue: 'rgb(0,70,101)'
      },
      {
        description: '',
        cssClass: '.section > div > div > div > div > div > div > input',
        cssProperty: 'background-color',
        cssValue: '#FDFCFF'
      },
      {
        description: '',
        cssClass: '.section > div > div > div > div',
        cssProperty: 'background-color',
        cssValue: '#FDFCFF'
      },
      {
        description: '',
        cssClass: '.section > div > div > div > div > label > label',
        cssProperty: 'color',
        cssValue: 'rgb(0,70,101)'
      },
      {
        description: '',
        cssClass: '.section > div',
        cssProperty: 'background-color',
        cssValue: '#FDFCFF'
      },
      {
        description: '',
        cssClass: '.section > div > div > div > div.input-wrapper',
        cssProperty: 'background-color',
        cssValue: '#FDFCFF'
      },
      {
        description: '',
        cssClass: '.section > div > div > div > div > div > input',
        cssProperty: 'background-color',
        cssValue: '#FDFCFF'
      },
      {
        description: '',
        cssClass: '.section > div > div > div > div',
        cssProperty: 'border',
        cssValue: 'none'
      },
      {
        description: '',
        cssClass: '.section > div > div > div > div',
        cssProperty: 'border',
        cssValue: '0px'
      },
      {
        description: '',
        cssClass: '.section',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Defaults',
    styles: [
      {
        description: '',
        cssClass: 'body',
        cssProperty: '--boxShadingSettings',
        cssValue: '0px 2px 4px #868e96'
      },
      {
        description: '',
        cssClass: 'body',
        cssProperty: '--boxShadingBorder',
        cssValue: '6px'
      },
      {
        description: '',
        cssClass: 'body',
        cssProperty: 'primaryColor',
        cssValue: '#fefefe'
      },
      {
        description: '',
        cssClass: 'body',
        cssProperty: '--accentColor',
        cssValue: '#00B9AC'
      },
      {
        description: 'Default background color for all components',
        cssClass: 'body',
        cssProperty: '--primaryBackground',
        cssValue: '#fefefe'
      },
      {
        description: '',
        cssClass: 'body',
        cssProperty: '--primaryLabelColor',
        cssValue: '#1F4578'
      },
      {
        description: '',
        cssClass: 'body',
        cssProperty: '--boxShadingInsetSettings',
        cssValue: 'inset 0 0 10px #000000'
      },
      {
        description: '',
        cssClass: 'body',
        cssProperty: '--primaryBackgroundDark',
        cssValue: 'gray'
      }
    ]
  },
  {
    label: 'Menu Header',
    styles: [
      {
        description: '',
        cssClass: '.MenuHeader',
        cssProperty: '--tabBackgroundColor',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: '.MenuHeader',
        cssProperty: '--tabAccentColor',
        cssValue: '#FFCA36'
      },
      {
        description: '',
        cssClass: '.MenuHeader',
        cssProperty: '--tabTextColor',
        cssValue: '#3C3D3D'
      }
    ]
  },
  {
    label: 'ImageFigure',
    styles: [
      {
        description: '',
        cssClass: '.ImageFigure > div',
        cssProperty: 'border',
        cssValue: 'none'
      },
      {
        description: '',
        cssClass: '.ImageFigure > div',
        cssProperty: 'background',
        cssValue: 'none'
      },
      {
        description: '',
        cssClass: '.ImageFigure',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Listviews',
    styles: [
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableBorderRadius',
        cssValue: '6px'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableBorderColor',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableBackgroundColor',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableLabelColor',
        cssValue: 'var(--primaryLabelColor)'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableRowHoverColor',
        cssValue: '#EBEBEB'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableTextColor',
        cssValue: '#4D4E4E'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableHeaderTextColor',
        cssValue: '#3C3D3D'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableHeaderBackgroundColor',
        cssValue: '#F1F3F7'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableSortedColumnTextColor',
        cssValue: 'var(--primaryLabelColor)'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: '--tableSelectedBackgroundColor',
        cssValue: '#EBEBEB'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: 'box-shadow',
        cssValue: 'var(--boxShadingSettings)'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: 'border-radius',
        cssValue: 'var(--boxShadingBorder)'
      },
      {
        description: '',
        cssClass: '.ListView',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Tab Component',
    styles: [
      {
        description: '',
        cssClass: '.Tabs',
        cssProperty: '--tabBackgroundColor',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: '.Tabs',
        cssProperty: '--tabTextColor',
        cssValue: '#3C3D3D'
      },
      {
        description: '',
        cssClass: '.Tabs',
        cssProperty: '--tabAccentColor',
        cssValue: '#FFCA36'
      },
      {
        description: '',
        cssClass: '.Tabs',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: '.Tabs',
        cssProperty: 'box-shadow',
        cssValue: 'var(--boxShadingSettings)'
      },
      {
        description: '',
        cssClass: '.Tabs',
        cssProperty: 'box-radius',
        cssValue: 'var(--boxShadingBorder)'
      },
      {
        description: '',
        cssClass: '.Tabs',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryColor)'
      }
    ]
  },
  {
    label: 'Buttons',
    styles: [
      {
        description: '',
        cssClass: '.Button',
        cssProperty: 'box-shadow',
        cssValue: 'var(--boxShadingSettings)'
      },
      {
        description: '',
        cssClass: '.Button',
        cssProperty: 'box-radius',
        cssValue: 'var(--boxShadingBorder)'
      },
      {
        description: '',
        cssClass: '.ActionButton',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackgroundDark)'
      },
      {
        description: '',
        cssClass: '.ActionButton',
        cssProperty: 'color',
        cssValue: 'var(--primaryBackgroundDark)'
      },
      {
        description: '',
        cssClass: '.button',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackgroundDark)'
      }
    ]
  },
  {
    label: 'Highlight',
    styles: [
      {
        description: 'Highlight Default Background Color',
        cssClass: '.highlight',
        cssProperty: 'backgroundColor',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: '.highlight',
        cssProperty: 'borderColor',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'FileList',
    styles: [
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableBorderRadius',
        cssValue: '6px'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableBorderColor',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableBackgroundColor',
        cssValue: 'primaryBackground'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableLabelColor',
        cssValue: 'var(--primaryLabelColor)'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableRowHoverColor',
        cssValue: '#EBEBEB'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableTextColor',
        cssValue: '#4D4E4E'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableHeaderTextColor',
        cssValue: '#3C3D3D'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableHeaderBackgroundColor',
        cssValue: '#F1F3F7'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableSortedColumnTextColor',
        cssValue: 'var(--primaryLabelColor)'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: '--tableSelectedBackgroundColor',
        cssValue: '#EBEBEB'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: 'box-shadow',
        cssValue: 'var(--boxShadingSettings)'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: 'border-radius',
        cssValue: 'var(--boxShadingBorder)'
      },
      {
        description: '',
        cssClass: '.FileList',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Email',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.BulkEmail',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: 'Standard background color for the component',
        cssClass: '.Email',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Calendar',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.Carousel',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Chatter Components',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.ChatterFeed',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: 'Standard background color for the component',
        cssClass: '.ChatterGroup',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: 'Standard background color for the component',
        cssClass: '.ChatterPeople',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Conditional',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.Conditional',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'ContactMerge',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.ContactMerge',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'CreditCheck',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.CreditCheck',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Other File Components',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.UploadFile',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      },
      {
        description: 'Standard background color for the component',
        cssClass: '.FilePreview',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'HTML',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.HTML',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Label',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.Label',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Link',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.Label',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'ListBreadcrumb',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.ListBreadCrumb',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Madocs',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.Madocs',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'MarketingCustom',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.MarketingCustom',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Party',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.Party',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'PDF',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.PDF',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'PuPicker',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.PuPicker',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'Repeater',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.Repeater',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'SearchBox',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.SearchBox',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'SearchResults',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.SearchResults',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  },
  {
    label: 'StatusBar',
    styles: [
      {
        description: 'Standard background color for the component',
        cssClass: '.StatusBar',
        cssProperty: 'background-color',
        cssValue: 'var(--primaryBackground)'
      }
    ]
  } */
]
